import React from 'react';
import PropTypes from 'prop-types';
import FA from 'utils/FA';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle';

const PaymentTestModeWarning = ({ testMode }) => {
  if (testMode) {
    return (
      <div className='test-mode-alert alert alert-warning'>
        <FA icon={faExclamationTriangle} postNbsp />
        Payment will not be collected because the system is in test mode.
      </div>
    );
  }
  return null;
};

PaymentTestModeWarning.propTypes = {
  testMode: PropTypes.bool.isRequired
};

export default PaymentTestModeWarning;
